//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ModuleTreeView from "src/components/loader/tree/ModuleTreeView";
import Paper from "@material-ui/core/Paper";
import ErrorMessageDialog, {useErrorMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  error: {
    color: "red",
  },
  checkbox: {
    paddingLeft: 0,
  },
  paper: {
    padding: 10,
  },
  button: {
    margin: 4,
  },
  expandablePanelIcon: {
    margin: 4,
  },
  expandablePanel: {
    paddingLeft: 10,
  },
}));
const AutomateOptionsPage = ({navigateToResults}) => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useErrorMessageDialog();

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Automation Modules Option</h5>
          <hr/>
        </Typography>

        <div>
          <ErrorMessageDialog {...errorMessage} />
          <p/>
          <Paper className={classes.paper}>
            <Typography variant="body2" color="textSecondary">
              <h6>Select the modules to be included in an automated extraction</h6>
            </Typography>
            <Typography variant="caption" color="textSecondary">
              The options defined here will be saved as a configuration profile.
              You can associate a database with a profile in the 'Automate Databases' dialog to control
              which modules are included when the automation runs. If nothing is defined, then the default list of modules is used. This only
              applies to P6-Loader Excel exports. For XML exports, the full project is always exported. Please remember that the
              options here are saved in your configuration definition, accessible via the button [Save & Load Definitions] at the bottom of this page.
            </Typography>
            <div className={classes.paper}>
              <Grid
                container
                spacing={1}
                justify="center"
                className={classes.root}
                alignItems="flex-start"
              >
                <Grid item xs={5}>
                  <ModuleTreeView path={"loader:automation:globalModules"}/>
                </Grid>
                <Grid item xs={5}>
                  <ModuleTreeView path={"loader:automation:projectModules"}/>
                </Grid>
              </Grid>
            </div>
          </Paper>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AutomateOptionsPage;
